import * as CubeTree from '../../../cubeTree/index';
import { shelfAddInfo } from './shelfAddInfo';
import { freezerAddInfo } from './freezerAddInfo';
import { partitionAddInfo } from './partitionAddInfo';
import { goodsAddInfo } from './goodsAddInfo';
import { textareaAddInfo } from './textareaAddInfo';
import { bafflePlateAddInfo } from './bafflePlateAddInfo';

function getInsertInfo(cubeData: FreeObjMap, insertTarget: CubeId, extendParams: FreeObjMap = {}): InsertInfo {
    if (CubeTree.isShelfCubeData(cubeData)) {
        return shelfAddInfo(cubeData, insertTarget, extendParams);
    }
    else if (CubeTree.isFreezerCubeData(cubeData)) {
        return freezerAddInfo(cubeData, insertTarget, extendParams);
    }
    else if (CubeTree.isPartitionCubeData(cubeData)) {
        return partitionAddInfo(cubeData, insertTarget, extendParams);
    }
    else if (CubeTree.isGoodsCubeData(cubeData)) {
        return goodsAddInfo(cubeData, insertTarget, extendParams);
    }
    else if (CubeTree.isTextareaCubeData(cubeData)) {
        return textareaAddInfo(cubeData, insertTarget, extendParams);
    }
    else if (CubeTree.isBafflePlateCubeData(cubeData)) {
        return bafflePlateAddInfo(cubeData, insertTarget, extendParams);
    }
    else {
        return null;
    }
}

export {
    getInsertInfo
};
